import { createTheme } from '@mui/material/styles';

// TODO: CSSBaseline breaks ui for now, but desired to add later

export const theme = createTheme({
    palette: {
        mode: 'light',
        error: {
            main: '#bf3b31',
            dark: '#b82722'
        },
        primary: {
            main: '#333D45',
            contrastText: '#fff',
            dark: '#242C30',
            light: '#5F696E'
        },
        secondary: {
            main: '#7DAB9B',
            contrastText: '#fff',
            dark: '#4F7C6D',
            light: '#ADDDCC'
        },
        text: {
            primary: 'rgba(0, 0, 0, 0.87)',
            secondary: 'rgba(0, 0, 0, 0.6)'
        }
    },
    typography: {
        fontSize: 20,
        fontFamily: 'Trebuchet MS'
    },
    components: {
        MuiUseMediaQuery: {
            defaultProps: {
                noSsr: true
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    zIndex: 100
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    display: 'flex',
                    justifyContent: 'center'
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                outlined: {
                    width: '390px',
                    zIndex: 50,
                    height: '29px',
                    borderRadius: 4,
                    fontSize: 14,
                    padding: '12px',
                    display: 'flex',
                    alignItems: 'center'
                },
                icon: {
                    zIndex: 100,
                    width: '24px',
                    height: 'auto',
                    top: '25%'
                }
            }
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    zIndex: 100
                }
            }
        },
        MuiBadge: {
            styleOverrides: {
                badge: {
                    zIndex: 100
                }
            }
        }
    }
});
